import { useGetApPrefectures } from 'ap-openapi';
import { useMemo } from 'react';

export const usePrefectureOptions = () => {
  const {
    data: prefecturesResponse,
    error,
    isLoading,
  } = useGetApPrefectures({
    query: {
      enabled: true,
    },
  });

  if (error) throw error;

  const prefectureOptions = useMemo(() => {
    if (!prefecturesResponse?.data) {
      return [];
    }

    return prefecturesResponse.data
      .filter(
        (prefecture) =>
          prefecture.id !== undefined && prefecture.name !== undefined
      )
      .map((prefecture) => ({
        value: prefecture.id!,
        label: prefecture.name!,
      }));
  }, [prefecturesResponse]);

  return { prefectureOptions, isLoading };
};
